import React from 'react';
import { usePlatformBranding } from '@/hooks/usePlatformBranding';
import { fetchInvoiceTemplate } from '@/hooks/useInvoiceTemplate';

// Trigger invoice template fetch once at module load (non-blocking)
fetchInvoiceTemplate();

interface BrandingProviderProps {
  children: React.ReactNode;
}

const BrandingProvider: React.FC<BrandingProviderProps> = ({ children }) => {
  // Non-blocking: trigger branding fetch but render children immediately
  usePlatformBranding();
  return <>{children}</>;
};

export default BrandingProvider;
